import React from 'react';
import T from 'prop-types';
import {
  InvestedBlock,
  InvestedBox,
  SidePanel
} from 'routes/App/cashback/styles';

const formatCurrency = (value) =>
  `$${(value || 0).toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1
  })}`;

const ResultsPanel = ({invested, generated, roi}) => {
  return (
    <SidePanel className='success'>
      <h4 className='panelTitle'>
        Your cashback program is delivering real results
      </h4>
      <div className='panelBody'>
        You invested {formatCurrency(invested)} in cashback credits —
        that&apos;s the total amount customers actually redeemed. Those
        customers came back and spent {formatCurrency(generated)} on their
        redemption orders.
      </div>
      <InvestedBlock>
        <InvestedBox>
          <div className='label'>Invested</div>
          <div className='value'>{formatCurrency(invested)}</div>
          <div className='hint'>in redeemed credits</div>
        </InvestedBox>
        <InvestedBox>
          <div className='label'>Generated</div>
          <div className='value'>{formatCurrency(generated)}</div>
          <div className='hint'>in redemption order revenue</div>
        </InvestedBox>
      </InvestedBlock>
      {roi != null && (
        <div className='panelBody' style={{marginTop: 10}}>
          That&apos;s a{' '}
          <b>
            {(roi || 0).toLocaleString('en-US', {
              minimumFractionDigits: 0,
              maximumFractionDigits: 1
            })}
            x return
          </b>{' '}
          on every dollar spent.
        </div>
      )}
    </SidePanel>
  );
};

ResultsPanel.propTypes = {
  invested: T.number,
  generated: T.number,
  roi: T.number
};

ResultsPanel.defaultProps = {
  invested: 0,
  generated: 0,
  roi: null
};

export default ResultsPanel;
